<template>
  <div class="devicesPage">
    <el-table
          stripe
      :data="tableData"
      border
      style="width: 100%"
      height="100%"
      size="mini"
      @sort-change="sortChange"
    >
      <el-table-column
        type="index"
        :width="pagination.endIndex >= 1000 ? 80:50"
        align="center"
        :index="pagination.beginIndex"
      ></el-table-column>
      <el-table-column prop="sn" label="SN" min-width="120" align="center" sortable="custom">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="scope.row.sn"
            placement="top"
            :open-delay="300"
          >
            <div class="textOverflow" v-if="scope.row.sn">{{scope.row.sn}}</div>
          </el-tooltip>
          <span v-if="!scope.row.sn">-</span>
        </template>
      </el-table-column>
      <el-table-column prop="uuid" label="UUID/PCBA" min-width="120" align="center">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="(scope.row.uuid || scope.row.pcbaSn) ? (scope.row.uuid ? scope.row.uuid : scope.row.pcbaSn):''"
            placement="top"
            :open-delay="300"
          >
            <div class="textOverflow" v-if="scope.row.uuid || scope.row.pcbaSn">{{scope.row.uuid ? scope.row.uuid : scope.row.pcbaSn}}</div>
          </el-tooltip>
          <span v-if="!scope.row.uuid && !scope.row.pcbaSn">-</span>
        </template>
      </el-table-column>
      <el-table-column prop="mac" label="MAC" min-width="120" align="center">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            placement="top"
            :open-delay="300"
          >
            <div slot="content" style="white-space: pre-wrap; word-break: break-all;">{{ JSON.stringify(scope.row.mac, null, 2) }}</div>
            <div class="textOverflow" v-if="scope.row.mac">{{scope.row.mac}}</div>
          </el-tooltip>
          <span v-if="!scope.row.mac">-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="deviceWeight"
        label="重量"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.deviceWeight">{{scope.row.deviceWeight}}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="productionOrder"
        min-width="120"
        label="组装工单"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.productionOrder">{{scope.row.productionOrder.orderNumber}}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="cartonOrder"
        min-width="120"
        label="包装工单"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.cartonOrder">{{scope.row.cartonOrder.orderNumber}}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="outer_ctn_index"
        label="外箱"
        min-width="120"
        align="center"
        show-overflow-tooltip
        sortable="custom"
      >
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.outerCtnSn" class="item" effect="dark" :content="scope.row.outerCtnSn" placement="top" :open-delay="300">
            <span v-if="scope.row.outerCtnIndex" class="textOverflow">
              第{{ scope.row.outerCtnIndex }}箱
              {{ scope.row.outerCtnWeight }}
            </span>
          </el-tooltip>
          <span v-if="!scope.row.outerCtnSn && scope.row.outerCtnIndex" class="textOverflow">
              第{{ scope.row.outerCtnIndex }}箱
              {{ scope.row.outerCtnWeight }}
          </span>
          <span v-if="!scope.row.outerCtnIndex">-</span>
        </template>
      </el-table-column><el-table-column
        prop="pallet_index"
        label="栈板"
        min-width="120"
        align="center"
        show-overflow-tooltip
        sortable="custom"
      >
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.palletSn" class="item" effect="dark" :content="scope.row.palletSn" placement="top" :open-delay="300">
            <span v-if="scope.row.palletIndex" class="textOverflow">
              第{{ scope.row.palletIndex }}栈板
            </span>
          </el-tooltip>
          <span v-if="!scope.row.palletSn && scope.row.palletIndex" class="textOverflow">
              第{{ scope.row.palletIndex }}栈板
          </span>
          <span v-if="!scope.row.palletIndex">-</span>
        </template>
      </el-table-column>
      <el-table-column v-if="tabPaneData.dpkStatus" prop="dpkStatus" width="95px" label="CBR" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.dpkCompleted" class="textOverflow">已确认</span>
          <span v-else-if="scope.row.dpkSubmitted" class="textOverflow">已提交</span>
          <span v-else class="textOverflow">待提交</span>
        </template>
      </el-table-column>
      <el-table-column prop="workStation" width="95px" label="状态" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.workStation" class="textOverflow">{{ scope.row.workStation.name }}</span>
          <span v-if="!scope.row.workStation">-</span>
        </template>
      </el-table-column>
      <el-table-column class-name="operation" label="操作" align="center" width="80px">
        <template slot-scope="scope">
          <el-tooltip
            v-if="tabPaneData.status.code == 'WAIT_SHIPMENT'"
            class="item"
            effect="dark"
            content="移除"
            placement="top"
            :open-delay="300"
          >
            <i @click="deleteDevice($event, scope.row)" class="iconfont icon-yichu"></i>
          </el-tooltip>
          <span v-else>-</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :pagination="pagination"
      @currentChange="currentChange"
      @sizeChange="sizeChange"
      @refreshBtn="getShipmentOrderDevices"
      :sumTotal="'/' + tabPaneData.quantity"
    ></pagination>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import {
  apiShipmentOrderDevices,
  apiProductionOrders,
  apiCartonOrders,
  apiShipmentOrderRemoveDevice
} from "@/api/shipmentOrder.js";
export default {
  components: {
    pagination
  },
  props: {
    tabPaneValue: {
      type: String
    },
    tabPaneData: {
      type: Object
    },
    devicesSearchForm: {
      type: Object
    }
  },
  data() {
    return {
      tableData: [],
      desc: undefined,
      orderBy: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10
      }
    };
  },
  methods: {
    // 表格数据
    async getShipmentOrderDevices(remove, callback) {
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }
      const res = await apiShipmentOrderDevices({
        shipmentOrderId: this.tabPaneValue,
        ...this.devicesSearchForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        desc: this.desc,
        orderBy: this.orderBy
      });
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
        if (callback) callback();
      }
    },
    // 移除
    deleteDevice(e, row) {
      e.target.blur();
      // console.log(row);
      this.$confirm(`确认移除${row.sn}吗？`, "产品移除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        const res = await apiShipmentOrderRemoveDevice({
          id: this.tabPaneValue,
          deviceId: row.id
        });
        if (res.code == 0) {
          this.getShipmentOrderDevices("noRemove");
          this.$message({
            type: "success",
            message: "移除成功"
          });
        }
      });
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getShipmentOrderDevices();
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.getShipmentOrderDevices();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.getShipmentOrderDevices();
    },
    // 查询条件--组装工单下拉
    async getProductionOrders() {
      const res = await apiProductionOrders({
        id: this.tabPaneValue
      });
      if (res.code == 0) {
        this.$parent.pullDownData.productionOrderList2 = res.data;
      }
    },
    // 添加产品-包装工单下拉
    async getCartonOrderList() {
      const res = await apiCartonOrders({
        id: this.tabPaneValue
      });
      if (res.code == 0) {
        this.$parent.pullDownData.cartonOrderList2 = res.data;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.devicesPage {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>